import EzController from 'controllers/ez-base-controller';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class EzModalController extends EzController {
  static targets = [
    'content',
  ]

  connect() {
    this.open();

    window.addEventListener('resize', this.detectHeightCutoff);
    window.addEventListener('keyup', this.allowEscClose);
    window.addEventListener(events.modal.close_modal, this.triggerClose);
  }

  disconnect() {
    window.removeEventListener('resize', this.detectHeightCutoff);
    window.removeEventListener('keyup', this.allowEscClose);
    window.removeEventListener(events.modal.close_modal, this.triggerClose);
  }

  open() {
    if (!document.body.classList.contains('has-active-modal')) {
      document.body.classList.add('has-active-modal');
    }

    this.element.classList.add('is-active');

    this.openModals = [...document.querySelectorAll('.ez-modal.is-active')];

    this.assignModalDepth();

    this.normalizeOverlayOpacity();

    if (this.element.hasAttribute('data-singled-out')) {
      this.hideShowOtherModals('hide');
    }

    this.resetModalFocus();

    this.detectHeightCutoff();

    this.element.setAttribute('data-opened', 'true');
  }

  close(event = null, beforeClose = () => { /* do nothing */ }, afterClose = () => { /* do nothing */ }) {
    if (event && (!event.keyCode && event.target !== event.currentTarget)) return;

    beforeClose(event);

    if (!this.element.hasAttribute('data-disable-easy-close')) {
      this.element.classList.remove('is-active');

      this.element.parentNode.removeChild(this.element);

      triggerCustomEvent('ModalClosed', {}, this.element);

      if (this.element.hasAttribute('data-singled-out')) {
        this.hideShowOtherModals('show');
      }

      this.openModals = [...document.querySelectorAll('.ez-modal.is-active')];

      if (this.highestModalIndex() > 0) {
        this.resetModalFocus();
        this.normalizeOverlayOpacity();
      }

      afterClose(event);
    }

    if (!document.querySelector('.ez-modal') && document.body.classList.contains('has-active-modal')) {
      document.body.classList.remove('has-active-modal');
    }
  }

  triggerClose = (event) => {
    this.close(event);
  }

  allowEscClose = (event) => {
    // Escape key maps to keycode `27`
    // Only close the topmost/focused modal
    if (event.keyCode === 27
        && (this.element === document.querySelector('.ez-modal[tabindex="-1"]'))) {
      this.close(event);
    }
  }

  assignModalDepth() {
    this.element.setAttribute('data-modal-depth-index', this.highestModalIndex() + 1);
  }

  confirm(event) {
    this.close(event);
    triggerCustomEvent('ConfirmModalConfirm', {}, event.target);
  }

  deny(event) {
    this.close(event);
    return false;
  }

  detectHeightCutoff = () => {
    if (this.contentTarget.parentNode.offsetHeight >= document.documentElement.clientHeight) {
      this.element.classList.add('is-too-tall');
    } else {
      this.element.classList.remove('is-too-tall');
    }
  }

  hideShowOtherModals(hideShow) {
    this.openModals.forEach((modal) => {
      if (modal !== this.element && !modal.classList.contains('ez-modal--parent-modal')) {
        if (hideShow === 'hide') {
          modal.classList.add('is-hidden');
        } else {
          modal.classList.remove('is-hidden');
        }
      }
    });
  }

  highestModalIndex() {
    const modalDepthIndexes = [];

    this.openModals.forEach((modal) => {
      const index = parseInt(modal.getAttribute('data-modal-depth-index'), 10) || 0;
      modalDepthIndexes.push(index);
    });

    return Math.max(...modalDepthIndexes);
  }

  normalizeOverlayOpacity() {
    if (document.querySelector('.ez-modal.is-top-modal')) {
      document.querySelector('.ez-modal.is-top-modal').classList.remove('is-top-modal');
    }

    const topModal = document.querySelector(`.ez-modal[data-modal-depth-index='${this.highestModalIndex()}']`);

    topModal.classList.add('is-top-modal');
  }

  resetModalFocus() {
    if (document.querySelector('.ez-modal[tabindex="-1"]')) {
      document.querySelector('.ez-modal[tabindex="-1"]').removeAttribute('tabindex');
    }

    const topModal = document.querySelector(`.ez-modal[data-modal-depth-index='${this.highestModalIndex()}']`);

    topModal.setAttribute('tabindex', -1);

    topModal.focus();
  }
}
